export const movies = [
  {
    id: "1001",
    title: "星际远征",
    year: 2025,
    duration: 148,
    rating: 8.7,
    region: "美国",
    director: "克里斯·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "汤姆·哈迪"],
    genres: ["科幻片", "动作片"],
    genreKeys: ["scifi", "action"],
    status: "高清",
    synopsis:
      "地球资源枯竭之际，一支由前宇航员组成的探险队穿越虫洞，前往遥远星系寻找人类新的家园。面对时间的错位与未知的宇宙，他们必须在亲情与使命之间做出艰难抉择。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20artwork%20showing%20a%20lone%20astronaut%20floating%20before%20a%20glowing%20wormhole%20in%20deep%20space%2C%20dramatic%20blue%20and%20amber%20lighting%2C%20volumetric%20light%20rays%2C%20highly%20detailed%20film%20poster%20composition%2C%20clean%20dark%20background%2C%20professional%20key%20art%20style&width=400&height=600&seq=movie-poster-1001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20a%20massive%20glowing%20wormhole%20surrounded%20by%20stars%20and%20nebulae%2C%20lone%20spacecraft%20silhouette%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20volumetric%20lighting%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed%2C%20dramatic%20atmosphere&width=1600&height=900&seq=movie-backdrop-1001&orientation=landscape",
    tags: ["太空", "硬科幻", "IMAX"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1002",
    title: "暗夜追凶",
    year: 2024,
    duration: 118,
    rating: 8.2,
    region: "中国大陆",
    director: "陈思诚",
    actors: ["王宝强", "刘昊然", "周迅"],
    genres: ["悬疑片", "犯罪片"],
    genreKeys: ["suspense", "crime"],
    status: "高清",
    synopsis:
      "一连串离奇的失踪案将刑警卷入一场跨越十年的迷局。随着线索逐渐浮出水面，真相却指向了最不可能的那个人。夜色之下，谁在说谎，谁在逃亡？",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20with%20a%20silhouetted%20detective%20standing%20in%20a%20rainy%20neon-lit%20alley%20at%20night%2C%20moody%20dark%20blue%20and%20orange%20reflections%20on%20wet%20pavement%2C%20mysterious%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20thriller%20scene%20of%20a%20rainy%20city%20street%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20asphalt%2C%20lone%20figure%20walking%20away%2C%20deep%20blue%20and%20orange%20color%20grading%2C%20film%20noir%20atmosphere%2C%20ultra%20wide%20cinematic%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1002&orientation=landscape",
    tags: ["犯罪", "反转", "烧脑"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1003",
    title: "笑闹一家亲",
    year: 2024,
    duration: 102,
    rating: 7.6,
    region: "中国大陆",
    director: "闫非",
    actors: ["沈腾", "马丽", "常远"],
    genres: ["喜剧片"],
    genreKeys: ["comedy"],
    status: "正片",
    synopsis:
      "一场突如其来的遗产风波，让原本鸡飞狗跳的三代同堂之家彻底乱作一团。为了守住老宅，一家人使出浑身解数，笑料百出的背后是割舍不断的亲情。",
    poster:
      "https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20movie%20poster%20showing%20a%20lively%20chaotic%20family%20group%20portrait%20in%20a%20cozy%20home%2C%20warm%20sunny%20yellow%20and%20orange%20tones%2C%20playful%20energetic%20expressions%2C%20clean%20flat%20background%2C%20modern%20film%20poster%20key%20art%20style%2C%20highly%20detailed&width=400&height=600&seq=movie-poster-1003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20comedic%20cinematic%20scene%20of%20a%20chaotic%20lively%20family%20gathering%20in%20a%20bright%20cozy%20living%20room%2C%20warm%20yellow%20and%20orange%20color%20grading%2C%20playful%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed%2C%20clean%20composition&width=1600&height=900&seq=movie-backdrop-1003&orientation=landscape",
    tags: ["合家欢", "爆笑", "温情"],
    isHot: true,
    isNew: false,
  },
  {
    id: "1004",
    title: "时间的尽头",
    year: 2024,
    duration: 136,
    rating: 8.9,
    region: "英国",
    director: "丹尼斯·维伦纽瓦",
    actors: ["艾米莉·布朗特", "莱昂纳多·迪卡普里奥"],
    genres: ["科幻片", "剧情片"],
    genreKeys: ["scifi", "drama"],
    status: "高清",
    synopsis:
      "一位物理学家发现时间正在以肉眼不可见的速度走向尽头。为了挽回逝去的爱人，他必须在宇宙熵增的终点前完成最后一次时空实验，而代价是抹去自己存在的痕迹。",
    poster:
      "https://readdy.ai/api/search-image?query=Artistic%20philosophical%20science%20fiction%20movie%20poster%20with%20a%20lone%20figure%20standing%20on%20a%20vast%20empty%20plain%20under%20a%20slowly%20dissolving%20sky%2C%20soft%20misty%20blue%20and%20grey%20tones%20with%20warm%20horizon%20glow%2C%20contemplative%20melancholic%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art&width=400&height=600&seq=movie-poster-1004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ethereal%20cinematic%20landscape%20of%20a%20lone%20figure%20on%20an%20immense%20empty%20plain%20beneath%20a%20dissolving%20glowing%20sky%2C%20soft%20misty%20blue%20and%20grey%20tones%20with%20warm%20horizon%20light%2C%20contemplative%20epic%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1004&orientation=landscape",
    tags: ["哲学", "时空", "催泪"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1005",
    title: "血色黎明",
    year: 2023,
    duration: 142,
    rating: 8.4,
    region: "美国",
    director: "史蒂文·斯皮尔伯格",
    actors: ["汤姆·汉克斯", "马特·达蒙"],
    genres: ["战争片", "剧情片"],
    genreKeys: ["war", "drama"],
    status: "高清",
    synopsis:
      "1944年的欧洲战场，一支小分队奉命深入敌后执行一项几乎不可能完成的任务。在炮火与牺牲之间，他们重新理解了勇气与同袍的真正含义。",
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20historical%20war%20movie%20poster%20showing%20a%20group%20of%20soldiers%20in%20silhouette%20against%20a%20fiery%20dawn%20sky%20with%20smoke%20and%20embers%2C%20muted%20olive%20and%20burning%20orange%20tones%2C%20dramatic%20epic%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20war%20scene%20of%20soldiers%20advancing%20across%20a%20smoking%20battlefield%20at%20dawn%2C%20fiery%20orange%20sky%2C%20smoke%20and%20embers%2C%20muted%20olive%20tones%2C%20dramatic%20historical%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1005&orientation=landscape",
    tags: ["战争", "史诗", "真实改编"],
    isHot: false,
    isNew: false,
  },
  {
    id: "1006",
    title: "山海奇缘",
    year: 2025,
    duration: 108,
    rating: 8.6,
    region: "中国大陆",
    director: "田晓鹏",
    actors: ["张杰", "刘校妤", "季冠霖"],
    genres: ["动画片"],
    genreKeys: ["animation"],
    status: "抢先版",
    synopsis:
      "少年为寻找失踪的姐姐，误入《山海经》中的奇幻世界，与神兽伙伴一同踏上冒险旅程。在这片瑰丽的东方秘境里，他学会了勇敢，也找回了家的方向。",
    poster:
      "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20movie%20poster%20featuring%20a%20brave%20young%20hero%20and%20a%20mythical%20beast%20in%20a%20magical%20oriental%20fantasy%20landscape%2C%20vibrant%20teal%20green%20and%20warm%20gold%20tones%2C%20eastern%20ink%20painting%20inspired%20style%2C%20highly%20detailed%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1006&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Magnificent%20oriental%20fantasy%20animated%20scene%20with%20floating%20mountains%2C%20mythical%20creatures%20and%20glowing%20lanterns%2C%20vibrant%20teal%20green%20and%20warm%20gold%20tones%2C%20eastern%20ink%20painting%20inspired%20aesthetic%2C%20ultra%20wide%20cinematic%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1006&orientation=landscape",
    tags: ["国漫", "奇幻", "合家欢"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1007",
    title: "心动信号",
    year: 2024,
    duration: 112,
    rating: 7.9,
    region: "韩国",
    director: "朴赞郁",
    actors: ["孙艺珍", "玄彬"],
    genres: ["爱情片", "剧情片"],
    genreKeys: ["romance", "drama"],
    status: "正片",
    synopsis:
      "两个在都市中各自奔忙的陌生人，因一次错拨的电话而相识。从误解到相知，他们在最不合适的时机遇见了最对的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20romance%20movie%20poster%20showing%20a%20couple%20in%20soft%20focus%20standing%20apart%20on%20a%20rainy%20city%20street%20at%20dusk%2C%20pastel%20pink%20and%20warm%20amber%20bokeh%20lights%2C%20tender%20melancholic%20mood%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1007&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dreamy%20romantic%20cinematic%20scene%20of%20a%20couple%20sharing%20an%20umbrella%20on%20a%20rainy%20city%20street%20at%20dusk%2C%20pastel%20pink%20and%20warm%20amber%20bokeh%20lights%2C%20tender%20emotional%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1007&orientation=landscape",
    tags: ["爱情", "治愈", "都市"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1008",
    title: "深海迷航",
    year: 2024,
    duration: 126,
    rating: 8.0,
    region: "美国",
    director: "詹姆斯·卡梅隆",
    actors: ["杰森·莫玛", "艾梅柏·希尔德"],
    genres: ["科幻片", "悬疑片"],
    genreKeys: ["scifi", "suspense"],
    status: "高清",
    synopsis:
      "一支深海科考队在马里亚纳海沟深处发现了一处未知文明的遗迹，随之而来的却是通讯中断与集体失忆。是科学无法解释的现象，还是一场精心策划的骗局？",
    poster:
      "https://readdy.ai/api/search-image?query=Underwater%20science%20fiction%20thriller%20movie%20poster%20showing%20a%20deep%20sea%20submersible%20descending%20into%20glowing%20dark%20ocean%20depths%2C%20bioluminescent%20blue%20and%20teal%20tones%2C%20mysterious%20eerie%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1008&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Deep%20underwater%20cinematic%20scene%20with%20a%20glowing%20submersible%20beam%20cutting%20through%20dark%20ocean%20depths%2C%20bioluminescent%20particles%2C%20deep%20blue%20and%20teal%20tones%2C%20mysterious%20suspenseful%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1008&orientation=landscape",
    tags: ["深海", "悬疑", "视效"],
    isHot: false,
    isNew: true,
  },
  {
    id: "1009",
    title: "都市夜归人",
    year: 2023,
    duration: 105,
    rating: 8.1,
    region: "中国大陆",
    director: "刁亦男",
    actors: ["易烊千玺", "周冬雨"],
    genres: ["剧情片"],
    genreKeys: ["drama"],
    status: "正片",
    synopsis:
      "一位深夜代驾司机在城市街巷间穿梭，载过形形色色的陌生人。每一段短暂的行程，都是一段不为人知的人生缩影。",
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20drama%20movie%20poster%20showing%20a%20lone%20driver%20in%20a%20car%20at%20night%20surrounded%20by%20blurred%20city%20lights%2C%20moody%20cool%20blue%20and%20warm%20amber%20reflections%2C%20intimate%20melancholic%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1009&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20night%20scene%20of%20a%20car%20driving%20through%20a%20glowing%20city%20with%20blurred%20bokeh%20lights%2C%20moody%20cool%20blue%20and%20warm%20amber%20reflections%2C%20intimate%20dramatic%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1009&orientation=landscape",
    tags: ["现实", "群像", "文艺"],
    isHot: false,
    isNew: false,
  },
  {
    id: "1010",
    title: "幽灵古堡",
    year: 2024,
    duration: 98,
    rating: 6.8,
    region: "美国",
    director: "温子仁",
    actors: ["维拉·法米加", "帕特里克·威尔森"],
    genres: ["恐怖片", "悬疑片"],
    genreKeys: ["horror", "suspense"],
    status: "抢先版",
    synopsis:
      "一群大学生为完成课题闯入传闻中的废弃古堡，却接连遭遇无法解释的诡异事件。当午夜钟声敲响，古堡隐藏百年的秘密被唤醒。",
    poster:
      "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20horror%20movie%20poster%20showing%20a%20looming%20gothic%20castle%20silhouette%20under%20a%20full%20moon%20with%20thick%20fog%2C%20deep%20desaturated%20teal%20and%20cold%20grey%20tones%2C%20ominous%20eerie%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1010&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Chilling%20cinematic%20horror%20scene%20of%20an%20abandoned%20gothic%20castle%20shrouded%20in%20thick%20fog%20under%20a%20full%20moon%2C%20deep%20desaturated%20teal%20and%20cold%20grey%20tones%2C%20ominous%20eerie%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1010&orientation=landscape",
    tags: ["惊悚", "氛围", "午夜场"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1011",
    title: "极速狂飙",
    year: 2024,
    duration: 121,
    rating: 7.8,
    region: "美国",
    director: "林诣彬",
    actors: ["范·迪塞尔", "杰森·斯坦森"],
    genres: ["动作片", "犯罪片"],
    genreKeys: ["action", "crime"],
    status: "高清",
    synopsis:
      "传奇车手为救出被绑架的兄弟，再度重返地下飙车世界。从街头到高速公路，一场关乎速度与生死的终极对决一触即发。",
    poster:
      "https://readdy.ai/api/search-image?query=High%20energy%20action%20racing%20movie%20poster%20showing%20a%20sports%20car%20speeding%20through%20city%20streets%20with%20motion%20blur%20and%20sparks%2C%20bold%20orange%20and%20steel%20grey%20tones%2C%20adrenaline%20fueled%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1011&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Thrilling%20cinematic%20car%20chase%20scene%20at%20night%20with%20a%20sports%20car%20drifting%20through%20neon%20city%20streets%2C%20motion%20blur%20trails%2C%20bold%20orange%20and%20steel%20grey%20tones%2C%20adrenaline%20charged%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1011&orientation=landscape",
    tags: ["飙车", "动作", "爽片"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1012",
    title: "王者归来",
    year: 2022,
    duration: 138,
    rating: 8.3,
    region: "中国香港",
    director: "吴宇森",
    actors: ["梁朝伟", "刘德华", "甄子丹"],
    genres: ["动作片", "战争片"],
    genreKeys: ["action", "war"],
    status: "高清",
    synopsis:
      "退役多年的特工被迫重出江湖，只为护送一位掌握关键情报的旧友穿越战区。昔日兄弟立场对立，家国大义与私人情谊在枪林弹雨中激烈碰撞。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylish%20Hong%20Kong%20action%20movie%20poster%20showing%20a%20sharp%20suited%20man%20holding%20a%20gun%20in%20dramatic%20smoky%20lighting%2C%20deep%20navy%20and%20crimson%20accent%20tones%2C%20cinematic%20heroic%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1012&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Stylish%20cinematic%20action%20scene%20of%20a%20sharp%20suited%20man%20walking%20through%20smoke%20with%20dramatic%20backlighting%2C%20deep%20navy%20and%20crimson%20accent%20tones%2C%20tense%20heroic%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1012&orientation=landscape",
    tags: ["枪战", "兄弟情", "港片"],
    isHot: false,
    isNew: false,
  },
  {
    id: "1013",
    title: "星空下的约定",
    year: 2025,
    duration: 106,
    rating: 8.5,
    region: "日本",
    director: "新海诚",
    actors: ["花泽香菜", "神木隆之介"],
    genres: ["爱情片", "动画片"],
    genreKeys: ["romance", "animation"],
    status: "抢先版",
    synopsis:
      "少年与少女在流星雨之夜许下约定，却因命运的捉弄分隔两地。多年后，当同一片星空再次亮起，他们是否还能找回当初的诺言？",
    poster:
      "https://readdy.ai/api/search-image?query=Beautiful%20anime%20romance%20movie%20poster%20showing%20two%20teenagers%20standing%20under%20a%20breathtaking%20starry%20night%20sky%20with%20shooting%20stars%2C%20vivid%20indigo%20and%20warm%20pink%20tones%2C%20dreamy%20emotional%20atmosphere%2C%20highly%20detailed%20anime%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1013&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Breathtaking%20anime%20cinematic%20scene%20of%20a%20vast%20starry%20night%20sky%20filled%20with%20shooting%20stars%20above%20a%20quiet%20Japanese%20town%2C%20vivid%20indigo%20and%20warm%20pink%20tones%2C%20dreamy%20romantic%20atmosphere%2C%20ultra%20wide%20anime%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1013&orientation=landscape",
    tags: ["新海诚", "青春", "治愈"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1014",
    title: "罪案现场",
    year: 2024,
    duration: 124,
    rating: 8.2,
    region: "美国",
    director: "大卫·芬奇",
    actors: ["布拉德·皮特", "摩根·弗里曼"],
    genres: ["犯罪片", "悬疑片"],
    genreKeys: ["crime", "suspense"],
    status: "高清",
    synopsis:
      "一桩看似普通的凶杀案，牵扯出一张盘根错节的腐败网络。两位性格迥异的警探必须放下成见，在被抹除的证据中找到唯一的真相。",
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20thriller%20movie%20poster%20showing%20a%20detective%20examining%20evidence%20under%20harsh%20forensic%20lighting%2C%20desaturated%20green%20and%20amber%20tones%2C%20tense%20investigative%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1014&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Gritty%20cinematic%20crime%20scene%20with%20forensic%20markers%20and%20harsh%20lighting%20in%20a%20dark%20urban%20alley%2C%20desaturated%20green%20and%20amber%20tones%2C%20tense%20investigative%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1014&orientation=landscape",
    tags: ["警匪", "推理", "暗黑"],
    isHot: false,
    isNew: true,
  },
  {
    id: "1015",
    title: "欢乐时光",
    year: 2023,
    duration: 99,
    rating: 7.3,
    region: "中国大陆",
    director: "大鹏",
    actors: ["大鹏", "乔杉", "柳岩"],
    genres: ["喜剧片"],
    genreKeys: ["comedy"],
    status: "正片",
    synopsis:
      "四个落魄的老友误打误撞办起了一家“专业”的婚庆公司，接二连三的乌龙订单让他们的创业之路笑料不断，也意外收获了人生的第二春。",
    poster:
      "https://readdy.ai/api/search-image?query=Festive%20bright%20comedy%20movie%20poster%20showing%20a%20group%20of%20cheerful%20friends%20celebrating%20with%20colorful%20confetti%2C%20warm%20sunny%20yellow%20and%20coral%20tones%2C%20joyful%20energetic%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1015&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Joyful%20cinematic%20comedy%20scene%20of%20friends%20celebrating%20together%20with%20colorful%20confetti%20and%20balloons%2C%20warm%20sunny%20yellow%20and%20coral%20tones%2C%20festive%20energetic%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1015&orientation=landscape",
    tags: ["喜剧", "友情", "治愈"],
    isHot: false,
    isNew: false,
  },
  {
    id: "1016",
    title: "凤凰重生",
    year: 2024,
    duration: 130,
    rating: 7.7,
    region: "中国香港",
    director: "陈木胜",
    actors: ["古天乐", "张家辉"],
    genres: ["动作片", "剧情片"],
    genreKeys: ["action", "drama"],
    status: "高清",
    synopsis:
      "一名被组织出卖的卧底在绝境中假死重生，为洗刷冤屈、伸张正义，他必须以全新的身份再次潜入最危险的地方。",
    poster:
      "https://readdy.ai/api/search-image?query=Intense%20action%20drama%20movie%20poster%20showing%20a%20determined%20man%20emerging%20from%20flames%20in%20silhouette%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20powerful%20rebirth%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1016&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Intense%20cinematic%20scene%20of%20a%20determined%20figure%20emerging%20from%20roaring%20flames%20at%20night%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20powerful%20dramatic%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1016&orientation=landscape",
    tags: ["卧底", "燃", "港式动作"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1017",
    title: "禁忌之地",
    year: 2022,
    duration: 101,
    rating: 7.2,
    region: "韩国",
    director: "罗泓轸",
    actors: ["黄政民", "李政宰"],
    genres: ["恐怖片", "悬疑片"],
    genreKeys: ["horror", "suspense"],
    status: "正片",
    synopsis:
      "一座与世隔绝的渔村接连发生渔民失踪事件，前来调查的记者发现村民们信奉着一种古老而危险的仪式，而真相远比传说更加可怕。",
    poster:
      "https://readdy.ai/api/search-image?query=Unsettling%20horror%20mystery%20movie%20poster%20showing%20a%20foggy%20remote%20fishing%20village%20with%20eerie%20glowing%20lights%2C%20cold%20desaturated%20blue%20green%20tones%2C%20dread%20filled%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1017&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Eerie%20cinematic%20scene%20of%20a%20foggy%20remote%20fishing%20village%20at%20dusk%20with%20unsettling%20glowing%20lights%2C%20cold%20desaturated%20blue%20green%20tones%2C%20dread%20filled%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1017&orientation=landscape",
    tags: ["民俗", "惊悚", "韩影"],
    isHot: false,
    isNew: false,
  },
  {
    id: "1018",
    title: "未来都市",
    year: 2025,
    duration: 133,
    rating: 8.4,
    region: "美国",
    director: "雷德利·斯科特",
    actors: ["瑞恩·高斯林", "安娜·德·阿玛斯"],
    genres: ["科幻片", "动作片"],
    genreKeys: ["scifi", "action"],
    status: "抢先版",
    synopsis:
      "在一个由人工智能统治的未来都市，一名赏金猎人奉命追捕叛逃的仿生人。随着调查深入，他开始质疑自己的身份与这座城市运转的全部规则。",
    poster:
      "https://readdy.ai/api/search-image?query=Neon%20cyberpunk%20science%20fiction%20movie%20poster%20showing%20a%20lone%20figure%20in%20a%20rain%20soaked%20futuristic%20city%20with%20towering%20holograms%2C%20vivid%20magenta%20and%20cyan%20neon%20reflections%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1018&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Stunning%20cyberpunk%20cinematic%20scene%20of%20a%20futuristic%20neon%20city%20at%20night%20with%20rain%20and%20towering%20holograms%2C%20vivid%20magenta%20and%20cyan%20neon%20reflections%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed%2C%20dramatic%20atmosphere&width=1600&height=900&seq=movie-backdrop-1018&orientation=landscape",
    tags: ["赛博朋克", "人工智能", "视效"],
    isHot: true,
    isNew: true,
  },
  {
    id: "1019",
    title: "平凡之路",
    year: 2023,
    duration: 115,
    rating: 8.8,
    region: "中国大陆",
    director: "文牧野",
    actors: ["张译", "章子怡"],
    genres: ["剧情片"],
    genreKeys: ["drama"],
    status: "高清",
    synopsis:
      "一位普通的外卖骑手在生活的重压下依然坚守善良，用一次次平凡的选择，照亮了身边人的人生。平凡之路，亦有微光。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20realistic%20drama%20movie%20poster%20showing%20a%20delivery%20rider%20walking%20through%20a%20sunlit%20ordinary%20city%20street%2C%20soft%20warm%20golden%20tones%2C%20hopeful%20grounded%20atmosphere%2C%20highly%20detailed%20film%20poster%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1019&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20realistic%20cinematic%20scene%20of%20an%20ordinary%20city%20street%20at%20sunrise%20with%20a%20lone%20rider%2C%20soft%20golden%20tones%2C%20hopeful%20grounded%20atmosphere%2C%20ultra%20wide%20film%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1019&orientation=landscape",
    tags: ["现实主义", "励志", "催泪"],
    isHot: true,
    isNew: false,
  },
  {
    id: "1020",
    title: "龙之传说",
    year: 2024,
    duration: 110,
    rating: 8.1,
    region: "中国大陆",
    director: "黄成希",
    actors: ["边江", "乔诗语"],
    genres: ["动画片", "动作片"],
    genreKeys: ["animation", "action"],
    status: "高清",
    synopsis:
      "少年与最后的龙族血脉缔结契约，为守护大陆踏上寻找失落神器的征途。宿命与勇气交织，一段荡气回肠的东方奇幻史诗就此展开。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20animation%20movie%20poster%20showing%20a%20young%20hero%20facing%20a%20majestic%20golden%20dragon%20against%20stormy%20clouds%2C%20dramatic%20teal%20and%20gold%20tones%2C%20epic%20heroic%20atmosphere%2C%20highly%20detailed%20anime%20key%20art%2C%20clean%20composition&width=400&height=600&seq=movie-poster-1020&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20animated%20scene%20of%20a%20majestic%20golden%20dragon%20soaring%20through%20stormy%20clouds%20above%20ancient%20mountains%2C%20dramatic%20teal%20and%20gold%20tones%2C%20ultra%20wide%20cinematic%20still%2C%20highly%20detailed&width=1600&height=900&seq=movie-backdrop-1020&orientation=landscape",
    tags: ["国漫", "热血", "东方奇幻"],
    isHot: false,
    isNew: true,
  },
];